module.exports = __webpack_public_path__ + "img/smartwater_card_icon.bdee5df4.svg";